module.exports = "<app-header></app-header>\n\n<router-outlet></router-outlet>\n\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main